import dayjs from "dayjs";
import { formatEngagementCount } from "../../utils/formatEngagementCount";
import type { ViewpointFeedPost } from "./ViewpointFeedTypes";

export const formatViewpointEngagementCount = formatEngagementCount;

function publishedAtMs(v: string | Date): number {
  if (v instanceof Date) {
    return v.getTime();
  }
  const d = dayjs(typeof v === "string" ? v.trim() : "");
  return d.isValid() ? d.valueOf() : 0;
}

function compareFeedDesc(a: ViewpointFeedPost, b: ViewpointFeedPost): number {
  const ta = publishedAtMs(a.publishedAt);
  const tb = publishedAtMs(b.publishedAt);
  if (ta !== tb) {
    return tb - ta;
  }
  return a.id < b.id ? 1 : a.id > b.id ? -1 : 0;
}

/** Feed 流按 publishedAt 降序 */
export function sortViewpointFeedByTimeDesc(items: ViewpointFeedPost[]): ViewpointFeedPost[] {
  return [...items].sort(compareFeedDesc);
}

/** 增量合并 Feed（新帖在前；不含置顶） */
export function mergeFeedIncoming(
  existing: ViewpointFeedPost[],
  incoming: ViewpointFeedPost[]
): ViewpointFeedPost[] {
  if (!incoming.length) {
    return existing;
  }
  const incomingById = new Map(incoming.map((p) => [p.id, p]));
  const seen = new Set(existing.map((p) => p.id));
  const updatedExisting = existing.map((p) => {
    const upd = incomingById.get(p.id);
    return upd ? { ...p, ...upd, pinned: false } : p;
  });
  const novel = incoming
    .filter((p) => !seen.has(p.id))
    .map((p) => ({ ...p, pinned: false }));
  if (!novel.length) {
    const changed = updatedExisting.some((p, i) => {
      const prev = existing[i];
      return !prev || prev.id !== p.id;
    });
    return changed ? sortViewpointFeedByTimeDesc(updatedExisting) : existing;
  }
  return sortViewpointFeedByTimeDesc([...novel, ...updatedExisting]);
}

/** 展示：置顶区 + Feed 流（feed 中与置顶同 id 的项仅隐藏展示，不改动 feed 缓存） */
export function buildViewpointDisplayItems(
  pinned: ViewpointFeedPost[],
  feed: ViewpointFeedPost[]
): ViewpointFeedPost[] {
  const pinnedIds = new Set(pinned.map((p) => p.id));
  const pinnedRows = pinned.map((p) => ({ ...p, pinned: true }));
  const feedRows = feed
    .filter((p) => !pinnedIds.has(p.id))
    .map((p) => ({ ...p, pinned: false }));
  return [...pinnedRows, ...feedRows];
}

export function patchViewpointPostInLists(
  pinned: ViewpointFeedPost[],
  feed: ViewpointFeedPost[],
  viewpointId: string,
  partial: Partial<ViewpointFeedPost>
): { pinned: ViewpointFeedPost[]; feed: ViewpointFeedPost[] } {
  const patch = (rows: ViewpointFeedPost[]) =>
    rows.map((r) => (r.id === viewpointId ? { ...r, ...partial } : r));
  return {
    pinned: patch(pinned),
    feed: patch(feed),
  };
}
